<template>
  <div class="tab-list">
    <ul>
      <li :class="tab==1?'is-active':''" @click="changeTab(1)">付费课程</li>
      <li :class="tab==2?'is-active':''" @click="changeTab(2)">VIP课程</li>
      <li :class="tab==0?'is-active':''" @click="changeTab(0)">免费课</li>
    </ul>
  </div>
</template>

<script>
export default {
  model: {
    prop: "tab",
    event: "tabChange",
  },
  props: {
    tab: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    changeTab(tab) {
      this.$emit("tabChange", tab);
    },
  },
};
</script>

<style lang="less" scoped>
.tab-list {
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  align-items: center;

  ul {
    display: flex;
    align-items: center;
    list-style: none;

    li {
      margin-right: 24px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      user-select: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .is-active {
      color: #222226;
    }

    .title {
      cursor: default;
    }
  }
}
</style>